class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this));

    // role="button" and the initial aria-expanded="false" are set directly in
    // the markup (ua_header.liquid) rather than here - this constructor runs
    // very early during page load, and setting them here was contributing to
    // a style-invalidation queue that later gets forced to flush synchronously
    // by other scripts on the page (Trustpilot's widget, search), a
    // measurable "forced reflow" cost. open()/close() still update
    // aria-expanded dynamically as the modal toggles.

    // Third-party widgets (e.g. search's autocomplete) can inject their
    // own suggestion markup into the tracked container after trapFocus() has
    // already snapshotted its first/last focusable elements, so Tab can walk
    // into that new content and straight back out without our trap noticing.
    // Closing on focusout once focus genuinely leaves everything search-related
    // (our own modal AND any active third-party autocomplete) catches that case
    // regardless of what the widget's own DOM shape turns out to be.
    document.addEventListener("focusout", this.onFocusOut.bind(this));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
  }

  onFocusOut() {
    if (!this.isOpen()) return;

    setTimeout(() => {
      const active = document.activeElement;
      if (this.contains(active)) return;
      if (active && active.closest(".ss__autocomplete--target")) return;

      this.close(false);
    });
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    this.summaryToggle.setAttribute("aria-expanded", "true");
    document.body.addEventListener("click", this.onBodyClickEvent);

    if (!event.target.classList.contains("header__icon--search")) {
      document.body.classList.add("overflow-hidden");
    }

    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    this.summaryToggle.setAttribute("aria-expanded", "false");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");

    // Defensively close search's autocomplete too - it's a third-party
    // widget outside our control, and closing our own modal shouldn't leave
    // its dropdown visually stuck open over the page.
    document.body.classList.remove("ss__autocomplete--active");
  }
}

customElements.define("details-modal", DetailsModal);
